var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-list",style:({height: _vm.height})},[_c('div',{staticClass:"quick-list-tabs",style:({padding:_vm.paddingTop})},[_vm._t("cardTop")],2),_c('div',{staticClass:"quick-list-content"},[_vm._t("cardconTent")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }